
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/termsAndConditions",
      function () {
        return require("private-next-pages/termsAndConditions/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/termsAndConditions"])
      });
    }
  